import React from 'react';
import ImageBottle from 'images/Supplement_Bottle.png';
import ImageSupplementFacts from 'images/supplement_v3_facts.png';
import ImageSupplementFactsMobile from 'images/supplement_v3_facts_mobile.png';
import { Button } from 'mui';

interface ModalBodySupplementInfoProps {
  onClose: () => void;
}

const ModalBodySupplementInfo: React.FC<ModalBodySupplementInfoProps> = ({ onClose }) => (
  <>
    <div className="flex flex-col gap-y-3 lg:gap-y-6">
      <img src={ImageBottle} alt="Product" />
      <h4>Maximus Building Blocks</h4>
      <p className="text-xs lg:text-sm">
        Maximus has the best multivitamin on the market, providing the {"'"}Building Blocks{"'"} for your body{"'"}s
        hormone and energy production. Other multivitamins use poorly absorbed forms and dosages of key fat-soluble
        Vitamins (A, D, E, K) that will never get you into optimal ranges. Building Blocks uniquely includes a
        bioavailable B-complex, patented Albion® trace minerals (copper, manganese, and molybdenum), and iodine to
        support optimal thyroid function.
      </p>
      <p className="text-xs lg:text-sm">
        Note that the recommended daily values (%DV) on supplement labels are just the bare minimum, not what{"'"}s
        optimal for health. Building Blocks was designed based on extensive medical research and clinical experience to
        create a prescription-strength formula that makes a meaningful difference in how you feel and perform.
      </p>
      <img
        sizes="(max-width: 456px) 350px, 650px"
        srcSet={`${ImageSupplementFactsMobile} 350w, ${ImageSupplementFacts} 650w`}
        src={ImageSupplementFactsMobile}
        alt="Supplement Facts"
      />
    </div>
    <hr />
    <Button onClick={onClose}>Done</Button>
  </>
);

export default ModalBodySupplementInfo;
